import SequenceListsFilter from 'crono-fe-common/components/SequencePicker/SequenceListsFilter';
import { List, ListType } from 'crono-fe-common/types/list';
import useSearchListsInfinite from 'hooks/services/lists/useSearchListInfinite';
import { useMemo, useState } from 'react';

//The hook's getNextPageParam only reports another page when a response fills
//the requested limit, so this has to stay at or below the API's page cap of 20
const LISTS_PAGE_SIZE = 20;

interface SequenceListsFilterContainerProps {
  selectedList: List | null;
  setSelectedList: (list: List | null) => void;
}

const SequenceListsFilterContainer = ({
  selectedList,
  setSelectedList,
}: SequenceListsFilterContainerProps) => {
  const [search, setSearch] = useState('');

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isSearchListsLoading,
  } = useSearchListsInfinite({
    type: ListType.Strategy,
    name: search || undefined,
    limit: LISTS_PAGE_SIZE,
  });

  const lists = useMemo(
    () => data?.pages.flatMap((page) => page.data?.data ?? []) ?? [],
    [data],
  );

  return (
    <SequenceListsFilter
      selectedList={selectedList}
      setSelectedList={setSelectedList}
      lists={lists}
      onSearchChange={setSearch}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      isLoading={isSearchListsLoading}
    />
  );
};

export default SequenceListsFilterContainer;
